import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const AccountDeletionSection = ({ onAccountDelete, className = '' }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [confirmationText, setConfirmationText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDeleteRequest = () => {
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (confirmationText !== 'حذف حساب') {
      return;
    }

    setIsDeleting(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      onAccountDelete?.();
    } catch (error) {
      console.error('Error deleting account:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    setShowDeleteModal(false);
    setConfirmationText('');
  };

  return (
    <div className={`space-y-6 ${className}`}>
      <div className="bg-error/10 border border-error/20 p-6 rounded-lg">
        <div className="flex items-start gap-4">
          <Icon name="AlertTriangle" size={24} className="text-error mt-1" />
          <div className="flex-1">
            <h3 className="text-lg font-medium text-error mb-2">
              حذف حساب کاربری
            </h3>
            <p className="text-sm text-foreground mb-4">
              با حذف حساب کاربری، تمام اطلاعات شما به صورت دائمی از سیستم حذف خواهد شد.
            </p>
            
            <div className="space-y-2 mb-6">
              <h4 className="text-sm font-medium text-foreground">
                اطلاعاتی که حذف خواهد شد:
              </h4>
              <ul className="text-sm text-muted-foreground space-y-1 mr-4">
                <li>• اطلاعات شخصی و حساب کاربری</li>
                <li>• تمام اطلاعات سالن‌ها و شعب</li>
                <li>• اطلاعات کارکنان و خدمات</li>
                <li>• تاریخچه نوبت‌ها و رزروها</li>
                <li>• گزارش‌ها و آمارها</li>
                <li>• تنظیمات و ترجیحات</li>
              </ul>
            </div>

            <div className="bg-warning/10 border border-warning/20 p-4 rounded-md mb-6">
              <div className="flex items-start gap-2">
                <Icon name="AlertCircle" size={16} className="text-warning mt-0.5" />
                <div>
                  <p className="text-sm text-foreground font-medium">
                    هشدار مهم
                  </p>
                  <p className="text-xs text-muted-foreground mt-1">
                    این عمل غیرقابل بازگشت است و امکان بازیابی اطلاعات وجود نخواهد داشت.
                  </p>
                </div>
              </div>
            </div>

            <Button
              variant="destructive"
              onClick={handleDeleteRequest}
              iconName="Trash2"
              iconPosition="right"
            >
              درخواست حذف حساب
            </Button>
          </div>
        </div>
      </div>
      {/* Delete confirmation modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-card border border-border rounded-lg shadow-elevation-5 w-full max-w-md animate-scale-in">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-error/10 rounded-full flex items-center justify-center">
                  <Icon name="AlertTriangle" size={24} className="text-error" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground">
                    تأیید حذف حساب
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    این عمل غیرقابل بازگشت است
                  </p>
                </div>
              </div>

              <div className="space-y-4 mb-6">
                <p className="text-sm text-foreground">
                  برای تأیید حذف حساب، عبارت <strong>"حذف حساب"</strong> را در کادر زیر وارد کنید:
                </p>

                <Input
                  type="text"
                  value={confirmationText}
                  onChange={(e) => setConfirmationText(e?.target?.value)}
                  placeholder="حذف حساب"
                  className="text-center"
                />

                <div className="bg-muted/50 p-3 rounded-md">
                  <p className="text-xs text-muted-foreground text-center">
                    پس از حذف حساب، تمام اطلاعات شما در مدت ۳۰ روز به صورت موقت نگهداری و سپس به طور کامل حذف خواهد شد.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <Button
                  variant="outline"
                  onClick={handleCancel}
                  disabled={isDeleting}
                  className="flex-1"
                >
                  انصراف
                </Button>
                <Button
                  variant="destructive"
                  onClick={handleConfirmDelete}
                  loading={isDeleting}
                  disabled={confirmationText !== 'حذف حساب'}
                  iconName="Trash2"
                  iconPosition="right"
                  className="flex-1"
                >
                  حذف دائمی حساب
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountDeletionSection;